import { Flame } from "lucide-react";
import { useTranslation } from "react-i18next";

interface FloatingStreakProps {
  streak: number;
}

/**
 * Floating streak indicator anchored to the left edge of the viewport.
 * Only renders when the user has an active streak.
 */
export function FloatingStreak({ streak }: FloatingStreakProps) {
  const { t } = useTranslation();
  if (!streak || streak <= 0) return null;

  return (
    <div
      className="fixed left-3 sm:left-4 top-1/2 -translate-y-1/2 z-40 pointer-events-none"
      aria-live="polite"
    >
      <div className="pointer-events-auto flex flex-col items-center gap-1 rounded-full bg-neon-pink text-white shadow-lg shadow-neon-pink/40 px-2.5 py-3 ring-2 ring-white/40 dark:ring-white/10 animate-in fade-in slide-in-from-left-4">
        <Flame className="size-5 sm:size-6" aria-hidden="true" />
        <span className="text-sm sm:text-base font-black leading-none tabular-nums">
          {streak}
        </span>
        <span className="sr-only">{t("streak.day", { count: streak })}</span>
      </div>
    </div>
  );
}
